import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { MarkdownService } from '../markdown.service';

/**
 * DOVE-1928: renders a note's markdown body as sanitized HTML for [innerHTML].
 *
 * Standalone + pure, so it is memoized per input (cheap across change detection)
 * and can be imported directly into any feature module that displays notes:
 *
 *   <span [innerHTML]="note.note | markdown"></span>
 *
 * Plain text (no markdown) is returned unchanged; raw markdown such as **bold**
 * or "- item" is rendered as formatted HTML — which also fixes legacy notes that
 * were stored with markdown syntax and previously showed the raw characters.
 */
@Pipe({
	name: 'markdown',
	standalone: true
})
export class MarkdownPipe implements PipeTransform {
	constructor(private markdownService: MarkdownService) {}

	transform(value: string | null | undefined): SafeHtml | string {
		return this.markdownService.processMarkdown(value ?? '');
	}
}
